import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

// Delete an Custom Source in a department
export const deleteCustomSource = async <T extends Record<string, unknown>>({
  data,
  domain,
  headers,
  query,
  departmentId,
  customSourceId,
  signal,
}: FetchRequestArgs & {
  departmentId: string;
  customSourceId: string;
}): Promise<ReturnType<typeof fetchRequest>> => {
  return fetchRequest<T>({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/custom_sources/${customSourceId}`,
    headers,
    method: HTTPMethod.DELETE,
    query,
    signal,
  });
};
